import Vue from "vue";
export default {
      SystemParameterUser:'01020000',
      ExportTransaction:'01050000',
  //mm : '02000000',
    //SystemSecurity : '02010000',
      UserGroup : '02010100',
      UserMaintenance : '02010200',
      ProgramSecurity : '02010300',
      UserGrpRightsShop:'02010500',
      ShopUserMaintenance : '02010600',

    //Setup : '02020000',
      FinancialPeriod : '02020100',
      Country : '02020300',
      District : '02020400',
      Currency : '02020500',
      Department : '02020600',
      LocationType : '02020700',
      Location : '02020800',
      TransactionType : '02020A00',
    //BusinessPartner:'02030000',
      BusinessEntity:'02030100',
      CustomerCategory:'02030200',
      VendorCategory:'02030300',
      PaymentTerm:'02030600',
      MiscellaneousCharges:'02030700',
      PriceClass:'02030800',
    //Others:'02040000',
      Remark:'02040200',
      Shops:'02060000',
      ShopMaintenance:'02060F00',
      BundleItems :'02060E00',
      MixandMatch:'02060D00',

      PurchaseOrder:'04010000',
      ClosePO:'04040000',
      POEnquiry:'04050200',
      POScheduleEnquiry:'04050400',
      PurchaseOrderApproval:'04060000',
      PurchaseAnalysis:'04080000',

      SalesOrder:'06040000',
      ConvertBatchSOtoInvoice : '06071000',
      Invoice:'06080100',
      PickingListPrinting:'06080300',
      InvoiceApproval:'06080400',
      InvoicePost: '06080401',
      TxPostXero: '06080402',
      InvoicePrinting:'06080500',
      ChangeInvoiceStatus:'06080600',
      ConvertPickingListtoInvoice:'06080800',
      Invoicesettlement:'06080D00',
      SalesOrderEnquiry:'060E0100',
      SalesTransactionEnquiry:'060E0200',
      SalesAnalysis:'060G0000',
      SalesTarget: '06010100',
      SalesReturn:'060F0100',
      SalesReturnApproval:'060F0200',
      CreditNotePrinting:'060F0400',
      SalesOrderEnquiry:'060E0400',
  
      Item:'07010100',
      ImportItemPriceClass:'07010101',
      Brand:'07010600',
      Category1:'07010700',
      Category2:'07010800',
      Bin:'07010900',
      Character:'07010A00',
      Series:'07010B00',
      ProductLineInCharge:'07010F00',
      ItemLine: '07010G00',

      GoodsReceive:'07020100',
      GoodsReceivePost:'07020101',
      VendorInvoice:'07020200',
      StockTransfer:'07030000',
      StockQuantityAdjustment:'07050000',
      CostAdjustment:'07060000',
      PurchaseReturn:'07070000',
      StockBalanceEnquiry:'07090300',
      GREnquiry:'07090800',
      StockBalanceMuti:'07091000',
      DeliverySummary:'07091100',
      StockAnalysis:'070B0000',
      EntityItemRef:'07010E01',
      StockTransactionEnquiry:'07090500',
      LoadStockTakeResult:'07080100',
      UpdateStockTakeVariance: '07080200',
      LabelTemplateCreation:'07011400',

      DataIntegrity:'08060000',
      StockMovementAnalysis:'09030000',
      MarketInfo:'11010000',
};

